import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMobile: false,
    language: true,
    kemiImageList:[
      "/fibroin/zt/微信图片_20250507131844.jpg",
      "/fibroin/zt/微信图片_20250507131848.jpg",
      "/fibroin/zt/微信图片_20250507131835.jpg",
      "/fibroin/zt/微信图片_20250507131851.jpg",
      "/fibroin/zt/微信图片_20250507131854.jpg",
      "/fibroin/zt/微信图片_20250507131841.jpg",
      "/fibroin/zt/微信图片_20250507131857.jpg",
      "/fibroin/zt/微信图片_20250623145122.jpg",
      "/fibroin/zt/微信图片_20250623145117.jpg",
    ],
      goodInfo:[
    {
      id:'8',
      name:'* 菲必丽专研口腔美白牙膏',
      img:'/fibroin/zt/微信图片_20250623145122.jpg',
      price:'68',
      remarks:'菲必丽专研口腔美白牙膏｜7天见证皓白蜕变',
      nameEn:' Fibroin ยาสีฟันขาวสูตรวิจัยพิเศษ',
      imgEn:'',
      priceEn:'320',
      remarksEn:'ยาสีฟันฟอกสีฟันสูตรเฉพาะของ Phiperit _ 7 Days Witness Hao Bai Change',
      url:'/fibroin/zt/微信图片_20250623154406.jpg'
    },
    {
      id:'9',
      name:'菲必丽专研口腔防蛀牙膏',
      img:'/fibroin/zt/微信图片_20250623145117.jpg',
      price:'68',
      remarks:'菲必丽专研口腔防蛀牙膏｜蛀牙狙击手·科学护龈',
      nameEn:' Fibroin ยาสีฟันป้องกันฟันผุ สูตรวิจัยพิเศษ',
      imgEn:'',
      priceEn:'320',
      remarksEn:'ยาสีฟันป้องกันฟันผุ _ ยาสีฟันป้องกันฟันผุ _ ยาสีฟันป้องกันฟันผุ',
      url:'/fibroin/zt/微信图片_20250623154410.jpg'
    },
    {
      id:'',
      name:'',
      img:'',
      price:'',
      remarks:'',
      nameEn:'',
      imgEn:'',
      priceEn:'',
      remarksEn:'',
    },
    {
      id:'',
      name:'',
      img:'',
      price:'',
      remarks:'',
      nameEn:'',
      imgEn:'',
      priceEn:'',
      remarksEn:'',
    },
    {
      id:'',
      name:'',
      img:'',
      price:'',
      remarks:'',
      nameEn:'',
      imgEn:'',
      priceEn:'',
      remarksEn:'',
    },
    {
      id:'',
      name:'',
      img:'',
      price:'',
      remarks:'',
      nameEn:'',
      imgEn:'',
      priceEn:'',
      remarksEn:'',
    },

  ],
  },

  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
